@if ({ isTop: isTopNav$ | async }; as navigation) {
    <div
        [ngClass]="{ open: !isCollapsed, 'is-js-desktop': isDesktop, 'is-js-mobile': !isDesktop }"
        [style.--color-nav-border]="bgHeader || null"
        [style.--color-nav-bg]="bgHeader || null"
        [style.--nav-active-font-weight]="mainNavActiveFontWeight || null"
        [style.--nav-text-hover]="mainNavHoverTextColor || null"
        [style.--nav-text-focus]="mainNavFocusTextColor || null"
        [style.background-color]="bgHeader || null"
        class="navbar-top">
        <div class="container--nav">
            <div class="navbar-top__inner d-flex align-items-center justify-content-between">
                <div class="navbar-left-wrapper d-flex align-items-center">
                    <core-brand-logo category="TOP-NAV"></core-brand-logo>
                </div>

                <nav
                    [ngClass]="{
                        'navbar-with-flyout': isNavbarWithFlyout,
                        'd-block d-nav-none': hideNavigationOnSplashLanding && !isLoggedIn,
                    }"
                    class="navbar navbar-expand-nav flex-grow-1"
                    role="navigation">
                    <div
                        [ngClass]="{
                            'navbar-remove-scroll': resetMobileScroll,
                            'is-mobile-nav-footer': showMobileNavFooter(),
                            show: !isCollapsed,
                        }"
                        [style.background-color]="bgNav || null"
                        class="collapse navbar-collapse"
                        id="navbarSupportedContent">
                        @if (searchEnabled && !noResultPreview) {
                            <core-client-search
                                (closeTopnavHamburgerNav)="isCollapsed = !isCollapsed"
                                [class.search-icon--is-dark]="bgNav ? !requiresContrastingTextColor(bgNav) : null"
                                [class.search-icon--is-light]="bgNav ? requiresContrastingTextColor(bgNav) : null"
                                [isSearchButtonIcon]="false"
                                [isDesktop]="isDesktop"
                                [customIcon]="customSearchIcon"
                                [customCloseIcon]="customCloseIcon"
                                [closeButtonSize]="closeButtonSize"
                                class="core-search-form--mobile">
                            </core-client-search>
                        }

                        <ul class="navbar-nav d-flex w-100">
                            @if (portalLink && !isLoggedIn && !isPortalLinkHidden) {
                                <li class="nav-item">
                                    <a
                                        [attr.target]="portalLinkTarget"
                                        [core-analytics]="{ action: 'SIGN IN TO MEMBER AREA', category: 'TOP-NAV' }"
                                        [href]="portalLink"
                                        [innerText]="'SIGN IN TO MEMBER AREA' | translate"
                                        class="btn btn-primary btn--outline btn--small btn--portal-link-mobile nav-link d-block align-self-start w-auto d-nav-none">
                                    </a>
                                </li>
                            }
                            @if (pages$ | async; as _pages) {
                                @for (
                                    page of $any(_pages | orderBy: ['displayOrder']);
                                    track trackByFn(i, page);
                                    let i = $index
                                ) {
                                    @if (page.children.length === 0 || page.meta.hideNavDropdown) {
                                        @if (showInMenu(page, 'no-child')) {
                                            <li
                                                [ngClass]="{ 'nav-item--posts': isDemoModeAndPostsLink(page) }"
                                                class="nav-item">
                                                <a
                                                    (click)="onNavItemClick(i, page, $event)"
                                                    [core-analytics]="{ action: page.url, category: 'TOP-NAV' }"
                                                    [id]="page.url"
                                                    [ngClass]="{
                                                        'is-active': setTopNavActiveLinkState(page),
                                                        active: setTopNavActiveLinkState(page),
                                                    }"
                                                    [attr.aria-current]="
                                                        setTopNavActiveLinkState(page) ? 'page' : 'false'
                                                    "
                                                    class="nav-link"
                                                    href="javascript:void(0)">
                                                    {{ page.meta.friendlyPageName || page.name }}
                                                </a>
                                            </li>
                                        }

                                        @if (isDemoMode && page.url === 'articles' && postsEnabled) {
                                            <li class="nav-item">
                                                <a
                                                    (click)="navigateToPage([page])"
                                                    [core-analytics]="{ action: page.url, category: 'TOP-NAV' }"
                                                    [id]="page.url"
                                                    [attr.aria-current]="
                                                        setTopNavActiveLinkState(page) ? 'page' : 'false'
                                                    "
                                                    class="nav-link nav-link--posts-demo"
                                                    href="javascript:void(0)">
                                                    {{ page.meta.friendlyPageName || page.name }}
                                                </a>
                                            </li>
                                        }
                                    }

                                    @if (page.children.length > 0) {
                                        @if (showInMenu(page, 'has-child')) {
                                            <li
                                                (isOpenChange)="onOpenChange($event, i)"
                                                (onShown)="onDropdownOpen()"
                                                [core-analytics]="{
                                                    action: 'Toggle ' + page.name,
                                                    category: 'TOP-NAV',
                                                }"
                                                class="nav-item dropdown"
                                                dropdown>
                                                <a
                                                    [ngClass]="{ 'is-active': setTopNavActiveLinkState(page) }"
                                                    aria-expanded="false"
                                                    class="nav-link dropdown-toggle page-dropdown-{{ page.url }}"
                                                    dropdownToggle
                                                    href="javascript:void(0)"
                                                    id="navbarDropdown"
                                                    role="button">
                                                    {{ page.name }}
                                                </a>

                                                @if (pillars$ | async; as content) {
                                                    <div
                                                        *dropdownMenu
                                                        [core-analytics]="{
                                                            action: 'Toggle ' + page.name,
                                                            category: 'TOP-NAV',
                                                        }"
                                                        [ngClass]="{
                                                            'dropdown-mobile': !isDesktop,
                                                            'dropdown-flyout':
                                                                menuStyle === 'flyout' ||
                                                                (isIndividualMenuFlyout &&
                                                                    menuFlyoutPageId === page.id),
                                                        }"
                                                        aria-labelledby="navbarDropdown"
                                                        class="dropdown-menu"
                                                        id="dropdown">
                                                        <div
                                                            [ngClass]="{
                                                                'dropdown-menu__with-posts': postsInNavEnabled,
                                                            }">
                                                            @if (!isCategoryNav || page.url !== 'benefits') {
                                                                @if (page.url !== 'life-journeys') {
                                                                    <div
                                                                        class="dropdown-wrapper dropdown-wrapper--no-category-nav">
                                                                        <div
                                                                            class="nav-menu-wrapper nav-menu-wrapper--{{
                                                                                activeMenuTab.value
                                                                            }} h-auto">
                                                                            <div class="row w-100">
                                                                                @if (includeParentPage) {
                                                                                    <div
                                                                                        class="nav-menu-item col-md-4 col-xl-3">
                                                                                        <a
                                                                                            (click)="
                                                                                                navigateToPage([page])
                                                                                            "
                                                                                            [attr.aria-label]="
                                                                                                'Learn more about ' +
                                                                                                (page.meta
                                                                                                    ?.friendlyPageName ||
                                                                                                    page.name) +
                                                                                                ' Overview'
                                                                                            "
                                                                                            [core-analytics]="{
                                                                                                action: page.url,
                                                                                                category: 'TOP-NAV',
                                                                                            }"
                                                                                            [ngClass]="{
                                                                                                active: setDropdownActiveLinkState(
                                                                                                    page
                                                                                                ),
                                                                                            }"
                                                                                            class="nav-menu-item__link"
                                                                                            href="javascript:void(0)">
                                                                                            <span
                                                                                                [innerText]="
                                                                                                    (page.meta
                                                                                                        ?.friendlyPageName ||
                                                                                                        page.name) +
                                                                                                    ' Overview'
                                                                                                "
                                                                                                class="nav-menu-item__name"></span>
                                                                                        </a>
                                                                                    </div>
                                                                                }
                                                                                @for (
                                                                                    child of $any(
                                                                                        page.children
                                                                                            | orderBy: [navigationOrder]
                                                                                    );
                                                                                    track child
                                                                                ) {
                                                                                    @if (
                                                                                        showInMenu(child, 'no-child')
                                                                                    ) {
                                                                                        <div
                                                                                            class="nav-menu-item col-md-4 col-xl-3">
                                                                                            <a
                                                                                                (click)="
                                                                                                    navigateToPage([
                                                                                                        page,
                                                                                                        child,
                                                                                                    ])
                                                                                                "
                                                                                                [attr.aria-label]="
                                                                                                    'Learn more about ' +
                                                                                                    child.name
                                                                                                "
                                                                                                [core-analytics]="{
                                                                                                    action: child.url,
                                                                                                    category: 'TOP-NAV',
                                                                                                }"
                                                                                                [ngClass]="{
                                                                                                    active: setDropdownActiveLinkState(
                                                                                                        child
                                                                                                    ),
                                                                                                }"
                                                                                                class="nav-menu-item__link"
                                                                                                href="javascript:void(0)">
                                                                                                <span
                                                                                                    [innerText]="
                                                                                                        child.name
                                                                                                    "
                                                                                                    class="nav-menu-item__name"></span>
                                                                                            </a>
                                                                                        </div>
                                                                                    }
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }

                                                                @if (page.url === 'life-journeys') {
                                                                    <div
                                                                        class="dropdown-wrapper dropdown-wrapper--no-category-nav life-journeys">
                                                                        <div
                                                                            class="nav-menu-wrapper nav-menu-wrapper--{{
                                                                                activeMenuTab.value
                                                                            }} h-auto">
                                                                            <div class="row h-100 w-100 g-2">
                                                                                @if (includeParentPage) {
                                                                                    <div
                                                                                        class="nav-menu-item col-12 col-md-3 d-flex">
                                                                                        <a
                                                                                            (click)="
                                                                                                navigateToPage([page])
                                                                                            "
                                                                                            [attr.aria-label]="
                                                                                                'Learn more about ' +
                                                                                                (page.meta
                                                                                                    ?.friendlyPageName ||
                                                                                                    page.name) +
                                                                                                ' Overview'
                                                                                            "
                                                                                            [core-analytics]="{
                                                                                                action: page.url,
                                                                                                category: 'TOP-NAV',
                                                                                            }"
                                                                                            [ngClass]="{
                                                                                                active: setDropdownActiveLinkState(
                                                                                                    page
                                                                                                ),
                                                                                            }"
                                                                                            class="nav-menu-item__link flex-column"
                                                                                            href="javascript:void(0)">
                                                                                            <span
                                                                                                class="nav-menu-item__name"
                                                                                                >{{
                                                                                                    page.meta
                                                                                                        ?.friendlyPageName ||
                                                                                                        page.name
                                                                                                }}
                                                                                                Overview</span
                                                                                            >
                                                                                            @if (page.description) {
                                                                                                <span
                                                                                                    class="nav-menu-item__desc"
                                                                                                    >{{
                                                                                                        page.description
                                                                                                            | limitTo
                                                                                                                : 85
                                                                                                    }}</span
                                                                                                >
                                                                                            }
                                                                                            <span
                                                                                                class="nav-menu-item__icon">
                                                                                                <img
                                                                                                    [alt]="
                                                                                                        page.meta
                                                                                                            ?.friendlyPageName ||
                                                                                                        page.name
                                                                                                    "
                                                                                                    [src]="
                                                                                                        validImageUrl(
                                                                                                            page
                                                                                                        )
                                                                                                    " />
                                                                                            </span>
                                                                                        </a>
                                                                                    </div>
                                                                                }
                                                                                @for (
                                                                                    child of $any(
                                                                                        page.children
                                                                                            | orderBy: [navigationOrder]
                                                                                    );
                                                                                    track child
                                                                                ) {
                                                                                    <div
                                                                                        class="nav-menu-item col-12 col-md-3 d-flex">
                                                                                        <a
                                                                                            (click)="
                                                                                                navigateToPage([
                                                                                                    page,
                                                                                                    child,
                                                                                                ])
                                                                                            "
                                                                                            [attr.aria-label]="
                                                                                                'Learn more about ' +
                                                                                                child.name
                                                                                            "
                                                                                            [core-analytics]="{
                                                                                                action: child.url,
                                                                                                category: 'TOP-NAV',
                                                                                            }"
                                                                                            [ngClass]="{
                                                                                                active: setDropdownActiveLinkState(
                                                                                                    child
                                                                                                ),
                                                                                            }"
                                                                                            class="nav-menu-item__link flex-column"
                                                                                            href="javascript:void(0)">
                                                                                            <span
                                                                                                class="nav-menu-item__name"
                                                                                                >{{ child.name }}</span
                                                                                            >
                                                                                            <span
                                                                                                class="nav-menu-item__desc"
                                                                                                >{{
                                                                                                    child.description
                                                                                                        | limitTo: 85
                                                                                                }}</span
                                                                                            >
                                                                                            <span
                                                                                                class="nav-menu-item__icon">
                                                                                                <img
                                                                                                    [alt]="child.name"
                                                                                                    [src]="
                                                                                                        validImageUrl(
                                                                                                            child
                                                                                                        )
                                                                                                    " />
                                                                                            </span>
                                                                                        </a>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            }
                                                        </div>

                                                        <div
                                                            [style.--color-nav-link]="linkColorVar || null"
                                                            [style.background-color]="bgNav || null"
                                                            class="dropdown-wrapper-mobile">
                                                            @if (
                                                                getMobileNavPages(page, content || null);
                                                                as mobilePages
                                                            ) {
                                                                @if (mobilePages.length > 0) {
                                                                    <div
                                                                        (click)="closeChildDropdown($event)"
                                                                        (keydown)="closeChildDropdown($event)"
                                                                        [style.--color-nav-link]="linkColorVar || null"
                                                                        class="nav-menu-item-back"
                                                                        tabindex="0">
                                                                        <div class="nav-menu-item-back__inner">
                                                                            <span class="nav-menu-item-back__icon">
                                                                                <svg
                                                                                    width="18"
                                                                                    height="18"
                                                                                    viewBox="0 0 24 24"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                                    <path
                                                                                        d="M15 18L9 12L15 6"
                                                                                        stroke="currentColor"
                                                                                        stroke-width="2"
                                                                                        stroke-linecap="round"
                                                                                        stroke-linejoin="round" />
                                                                                </svg>
                                                                            </span>
                                                                            <span class="nav-menu-item-back__text"
                                                                                >Go Back</span
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                    <ul class="benefits-nav-list">
                                                                        @if (includeParentPage) {
                                                                            <li class="benefits-nav-list__item">
                                                                                <a
                                                                                    (click)="navigateToPage([page])"
                                                                                    [core-analytics]="{
                                                                                        action: page.url,
                                                                                        category: 'TOP-NAV',
                                                                                    }"
                                                                                    [innerText]="
                                                                                        (page.meta?.friendlyPageName ||
                                                                                            page.name) + ' Overview'
                                                                                    "
                                                                                    href="javascript:void(0)">
                                                                                </a>
                                                                            </li>
                                                                        }
                                                                        @for (
                                                                            navPage of $any(
                                                                                mobilePages | orderBy: [navigationOrder]
                                                                            );
                                                                            track trackByFn(i, navPage);
                                                                            let i = $index
                                                                        ) {
                                                                            <li class="benefits-nav-list__item">
                                                                                <a
                                                                                    (click)="navigateToPage([navPage])"
                                                                                    [core-analytics]="{
                                                                                        action: navPage.url,
                                                                                        category: 'TOP-NAV',
                                                                                    }"
                                                                                    [innerText]="navPage.name"
                                                                                    href="javascript:void(0)">
                                                                                </a>
                                                                            </li>
                                                                        }
                                                                    </ul>
                                                                }
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </li>
                                        }
                                    }
                                }
                            }

                            @if (isLoggedIn && !isDesktop && !isSplashLandingCurrentPage && showLogoutButton) {
                                <li class="nav-item">
                                    <a
                                        (click)="logout()"
                                        [core-analytics]="{ action: 'Logout', category: 'TOP-NAV' }"
                                        class="nav-link d-flex align-items-center"
                                        href="javascript:void(0)">
                                        {{ 'Logout' | translate }}
                                        <span class="material-symbols-outlined ms-1">{{ 'Logout' | translate }}</span>
                                    </a>
                                </li>
                            }

                            @if (!isCollapsed && showMobileNavFooter()) {
                                <div [style.background-color]="bgNav || null" class="fixed-mobile-nav-footer">
                                    <span class="nav-link">
                                        @if (contactEnabled) {
                                            <a
                                                [core-analytics]="{ action: 'Get in touch', category: 'TOP-NAV' }"
                                                class="btn btn-primary mb-0"
                                                routerLink="/contact">
                                                {{ 'Get in touch?' | translate }}
                                            </a>
                                        }
                                        @if (contactEnabled && customContactButtonEnabled) {
                                            <span class="ms-2"></span>
                                        }
                                        @if (customContactButtonEnabled) {
                                            <a
                                                [core-analytics]="{
                                                    action: customContactButtonText,
                                                    category: 'TOP-NAV',
                                                }"
                                                [target]="customContactButtonTarget ? '_blank' : '_self'"
                                                class="btn mb-0"
                                                [style.background-color]="customContactButtonActionBg || null"
                                                [style.color]="customContactButtonActionText || null"
                                                [href]="customContactButtonPath"
                                                [innerHTML]="customContactButtonText | translate">
                                            </a>
                                        }
                                        @if (enrollButtonEnabled && !isEnrollButtonHidden) {
                                            <a
                                                [core-analytics]="{ action: enrollButtonText, category: 'TOP-NAV' }"
                                                [href]="enrollButtonPath"
                                                [target]="enrollButtonTarget"
                                                class="btn btn--small mb-0 w-100"
                                                [style.background-color]="enrollButtonActionBg || null"
                                                [style.color]="enrollButtonActionText || null">
                                                <span [innerHTML]="enrollButtonText | translate"></span>
                                                @if (enrollButtonShowExternalLinkIcon) {
                                                    <ng-container *ngTemplateOutlet="externalLinkIcon"></ng-container>
                                                }
                                            </a>
                                        }
                                    </span>
                                </div>
                            }

                            @if (!isDesktop && (canShowUtilitiesAbove || canShowUtilitiesBelow)) {
                                <hr />
                                @if (utilitiesPages$ | async; as utilPages) {
                                    @for (page of utilPages; track page.id; let idx = $index) {
                                        @if (page.children && page.children.length > 0) {
                                            <li
                                                (isOpenChange)="onOpenChange($event, 'util-' + idx)"
                                                (onShown)="onDropdownOpen()"
                                                [core-analytics]="{
                                                    action: 'Toggle ' + page.name,
                                                    category: 'TOP-NAV',
                                                }"
                                                class="nav-item dropdown"
                                                dropdown>
                                                <a
                                                    aria-expanded="false"
                                                    class="nav-link dropdown-toggle page-dropdown-{{ page.url }}"
                                                    dropdownToggle
                                                    href="javascript:void(0)"
                                                    role="button">
                                                    {{ page.meta?.['friendlyPageName'] || page.name }}
                                                </a>
                                                <div
                                                    *dropdownMenu
                                                    [core-analytics]="{
                                                        action: 'Toggle ' + page.name,
                                                        category: 'TOP-NAV',
                                                    }"
                                                    class="dropdown-menu dropdown-mobile"
                                                    id="dropdown">
                                                    <div
                                                        [style.--color-nav-link]="linkColorVar || null"
                                                        [style.background-color]="bgNav || null"
                                                        class="dropdown-wrapper-mobile">
                                                        <div
                                                            (click)="closeChildDropdown($event)"
                                                            (keydown)="closeChildDropdown($event)"
                                                            [style.--color-nav-link]="linkColorVar || null"
                                                            class="nav-menu-item-back"
                                                            tabindex="0">
                                                            <div class="nav-menu-item-back__inner">
                                                                <span class="nav-menu-item-back__icon">
                                                                    <svg
                                                                        width="18"
                                                                        height="18"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M15 18L9 12L15 6"
                                                                            stroke="currentColor"
                                                                            stroke-width="2"
                                                                            stroke-linecap="round"
                                                                            stroke-linejoin="round" />
                                                                    </svg>
                                                                </span>
                                                                <span class="nav-menu-item-back__text">Go Back</span>
                                                            </div>
                                                        </div>
                                                        <ul class="benefits-nav-list">
                                                            @if (addParentPageToUtilityMenu) {
                                                                <li class="benefits-nav-list__item">
                                                                    <a
                                                                        (click)="navigateUtilityPage(page)"
                                                                        [core-analytics]="{
                                                                            action: page.url,
                                                                            category: 'TOP-NAV',
                                                                        }"
                                                                        [innerText]="
                                                                            (page.meta?.['friendlyPageName'] ||
                                                                                page.name) + ' Overview'
                                                                        "
                                                                        href="javascript:void(0)">
                                                                    </a>
                                                                </li>
                                                            }
                                                            @for (
                                                                child of $any(
                                                                    page.children | orderBy: [navigationOrder]
                                                                );
                                                                track child.id
                                                            ) {
                                                                @if (showInUtilityMenu(child)) {
                                                                    <li class="benefits-nav-list__item">
                                                                        <a
                                                                            (click)="navigateUtilityPage(page, child)"
                                                                            [core-analytics]="{
                                                                                action: child.url,
                                                                                category: 'TOP-NAV',
                                                                            }"
                                                                            [innerText]="
                                                                                child.meta?.['friendlyPageName'] ||
                                                                                child.name
                                                                            "
                                                                            href="javascript:void(0)">
                                                                        </a>
                                                                    </li>
                                                                }
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                        } @else {
                                            <li class="nav-item">
                                                <a
                                                    (click)="navigateToPage([page])"
                                                    [core-analytics]="{ action: page.url, category: 'TOP-NAV' }"
                                                    class="nav-link"
                                                    href="javascript:void(0)">
                                                    {{ page.meta?.['friendlyPageName'] || page.name }}
                                                </a>
                                            </li>
                                        }
                                    }
                                }
                            }
                        </ul>
                    </div>
                </nav>

                <div class="navbar-top__icons d-flex align-items-center" [style.color]="'var(--color-nav-icon)'">
                    @if (isLoggedIn && displayLoggedInUser) {
                        <p class="navbar-logged-in-name d-none d-nav-block mb-0 me-3">
                            {{ 'Logged in' | translate }}
                            @if (loggedInUserName) {
                                {{ 'as:' | translate }} <span [innerText]="loggedInUserName"></span>
                            }
                        </p>
                    }
                    @if (enrollButtonEnabled && isDesktop && !isEnrollButtonHidden) {
                        <a
                            [core-analytics]="{ action: enrollButtonText, category: 'TOP-NAV' }"
                            [href]="enrollButtonPath"
                            [target]="enrollButtonTarget"
                            class="btn btn-primary btn--small mb-0 d-none d-nav-block me-2"
                            [style.background-color]="enrollButtonActionBg || null"
                            [style.color]="enrollButtonActionText || null">
                            <span [innerHTML]="enrollButtonText | translate"></span>
                            @if (enrollButtonShowExternalLinkIcon) {
                                <ng-container *ngTemplateOutlet="externalLinkIcon"></ng-container>
                            }
                        </a>
                    }
                    @if (searchEnabled) {
                        <core-client-search
                            [ngClass]="{ 'd-none d-nav-block': !noResultPreview }"
                            [style.color]="'var(--color-nav-icon)'"
                            [style.--color-nav-link-active]="'var(--color-nav-icon)'"
                            [class.search-icon--is-dark]="bgHeader ? !requiresContrastingTextColor(bgHeader) : null"
                            [class.search-icon--is-light]="bgHeader ? requiresContrastingTextColor(bgHeader) : null"
                            [isSearchButtonIcon]="true"
                            [customIcon]="customSearchIcon"
                            [customCloseIcon]="customCloseIcon"
                            [closeButtonSize]="closeButtonSize">
                        </core-client-search>
                    }

                    @if (notificationsEnabled && navigation.isTop) {
                        <core-notifications></core-notifications>
                    }

                    @if (showDarkModeSwitch) {
                        <core-dark-mode-toggle></core-dark-mode-toggle>
                    }

                    <core-client-block-language></core-client-block-language>

                    @if (contactEnabled) {
                        <a
                            [core-analytics]="{ action: 'Get in touch', category: 'TOP-NAV' }"
                            class="btn btn-primary btn--small mb-0 d-none d-nav-block ms-2"
                            routerLink="/contact">
                            {{ 'Get in touch?' | translate }}
                        </a>
                    }
                    @if (customContactButtonEnabled) {
                        <a
                            [core-analytics]="{ action: customContactButtonText, category: 'TOP-NAV' }"
                            [target]="customContactButtonTarget ? '_blank' : '_self'"
                            class="btn btn--small mb-0 d-none d-nav-block ms-2"
                            [ngClass]="[customContactButtonIcon ? 'btn-icon-contact' : '']"
                            [style.background-color]="customContactButtonActionBg || null"
                            [style.color]="customContactButtonActionText || null"
                            [href]="customContactButtonPath"
                            [innerHTML]="customContactButtonText | translate">
                        </a>
                    }

                    @if (portalLink && !isLoggedIn && !isPortalLinkHidden) {
                        <a
                            [attr.target]="portalLinkTarget"
                            [core-analytics]="{ action: 'SIGN IN TO MEMBER AREA', category: 'TOP-NAV' }"
                            [href]="portalLink"
                            [innerText]="'SIGN IN TO MEMBER AREA' | translate"
                            class="btn btn-primary btn--outline btn--small mb-0 d-none d-nav-block ms-2">
                        </a>
                    }

                    @if (isLoggedIn && !isSplashLandingCurrentPage && showLogoutButton) {
                        <a
                            (click)="logout()"
                            [core-analytics]="{ action: 'Logout', category: 'TOP-NAV' }"
                            class="logout-btn btn btn-dark btn--icon-right btn--small mb-0 d-none d-nav-block ms-2"
                            href="javascript:void(0)">
                            {{ 'Logout' | translate }}
                            <span aria-hidden="true" class="material-symbols-outlined">{{ 'Logout' | translate }}</span>
                        </a>
                    }

                    <button
                        (click)="toggleMobileMenu($event)"
                        [attr.aria-expanded]="!isCollapsed"
                        [core-analytics]="{ action: 'Toggle navigation', category: 'TOP-NAV' }"
                        [ngClass]="{
                            open: !isCollapsed,
                            'navbar-toggler--dark': !heroImagesEnabled,
                            'd-none': hideMobileNavigationOnSplashLanding,
                        }"
                        aria-controls="navbarSupportedContent"
                        aria-label="Toggle navigation"
                        class="navbar-toggler ms-2"
                        data-bs-target="#navbarSupportedContent"
                        data-bs-toggle="collapse"
                        id="mobile-nav-icon"
                        type="button">
                        @if (customBurgerIcon) {
                            <img [src]="customBurgerIcon" class="custom-burger-icon" alt="Menu" />
                        } @else {
                            <!-- Use icon color so burger matches header contrast (not link color) -->
                            <span [style.background-color]="'var(--color-nav-icon, var(--color-text, #000))'"></span>
                            <span [style.background-color]="'var(--color-nav-icon, var(--color-text, #000))'"></span>
                            <span [style.background-color]="'var(--color-nav-icon, var(--color-text, #000))'"></span>
                            <span [style.background-color]="'var(--color-nav-icon, var(--color-text, #000))'"></span>
                        }
                    </button>
                </div>

                <ng-template #externalLinkIcon>
                    <svg
                        class="external-link-icon"
                        fill="none"
                        height="24"
                        viewBox="0 0 26 24"
                        width="26"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.6602 7H6.3923C5.22856 7 4.28516 7.89543 4.28516 9V18C4.28516 19.1046 5.22856 20 6.3923 20H15.8744C17.0382 20 17.9816 19.1046 17.9816 18V13"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2" />
                        <path
                            d="M10.6055 14L21.1412 4"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2" />
                        <path
                            d="M15.875 4H21.1429V9"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2" />
                    </svg>
                </ng-template>
            </div>
        </div>
    </div>
}
